// Belantti variant fallback: price, availability + cart variant id (v3.3)
// Gallery/media changes are intentionally handled only by belantti-variant-swatch-fix.js v4.0.
(function(){
  if (window.__belanttiVariantFixLoaded) return;
  window.__belanttiVariantFixLoaded = true;

  window.shopCurrency = '£';
  if (typeof Shopify === 'undefined') window.Shopify = {};
  Shopify.money_format = '£{{amount}}';

  function formatMoney(cents){
    var value = (parseInt(cents, 10) / 100).toFixed(2);
    return '£' + value;
  }

  function updatePriceElements(variant){
    try {
      var priceEl = document.querySelector('.engoj_price_main, .product-price .price, .price-item--regular');
      var compareEl = document.querySelector('.enj-product-price-compare, .price-item--compare');

      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      if (compareEl){
        if (variant.compare_at_price && variant.compare_at_price > variant.price){
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
    } catch(e){
      console.warn('Variant price update error', e);
    }
  }

  function updateATC(variant){
    var btn = document.querySelector('form[action^="/cart/add"] [type="submit"], #AddToCart, .product-add-to-cart');
    var txt = btn ? (btn.querySelector('span, .text') || btn) : null;
    if (!btn) return;

    if (variant && variant.available){
      btn.removeAttribute('disabled');
      if (txt) txt.textContent = 'Add to cart';
    } else {
      btn.setAttribute('disabled', 'disabled');
      if (txt) txt.textContent = 'Sold out';
    }
  }

  function updateVariantId(variant){
    try {
      var input = document.querySelector('form[action^="/cart/add"] [name="id"]');
      if (input) input.value = variant.id;
    } catch(e){}
  }

  document.addEventListener('change', function(e){
    var t = e.target;
    if (!t || (t.name !== 'id' && t.id !== 'productSelect')) return;

    try {
      var productJsonEl = document.querySelector('[data-product-json], script[type="application/json"][data-product]');
      var productObj = null;

      if (productJsonEl) {
        productObj = JSON.parse(productJsonEl.textContent.trim());
      } else if (window.meta && window.meta.product) {
        productObj = window.meta.product;
      }

      if (!productObj || !productObj.variants) return;

      var selectedId = parseInt(t.value, 10);
      var variant = productObj.variants.find(function(v){ return v.id === selectedId; });
      if (!variant) return;

      updatePriceElements(variant);
      updateATC(variant);
      updateVariantId(variant);
    } catch(err){
      console.warn('Variant switch error', err);
    }
  }, true);
})();
